import { ListingRemoteUrlResponseSchema } from "../schemas/api/listings/remote-url";

/**
 * Resolve a listing's click-out URL from the database.
 *
 * Product pages are statically rendered, so a page built before the listing's
 * metadata row carried a URL keeps serving a click-out button with nothing
 * behind it. This is the live fallback for that case.
 *
 * Returns null on any failure — the caller is expected to log the miss with
 * enough context to tell a stale page from a listing that never had a URL.
 */
export async function fetchListingRemoteUrl(
  listingId: number,
): Promise<string | null> {
  if (!Number.isFinite(listingId) || listingId <= 0) return null;

  try {
    const response = await fetch(
      `/api/listing-remote-url?listingId=${listingId}`,
    );
    if (!response.ok) return null;

    const parsed = ListingRemoteUrlResponseSchema.safeParse(
      await response.json(),
    );
    return parsed.success ? parsed.data.remote_url : null;
  } catch {
    return null;
  }
}
